import { Box, Button, Typography } from "@mui/material";
import { FilterAltOffOutlined } from "@mui/icons-material";
import { colors } from "../../ui/colors";

interface Props {
    onClearFilters?: () => void;
}

export default function EmptyTimesheetState({ onClearFilters }: Props) {
    return (
        <Box
            sx={{
                width: "100%",
                minHeight: 280,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                px: 3,
                py: 6,
            }}
        >
            <Box
                sx={{
                    maxWidth: 420,
                    width: "100%",
                    textAlign: "center",
                    p: 4,
                    borderRadius: 4,
                    bgcolor: "var(--fx-surface-sunken, #F8FAFC)",
                    border: "1px dashed var(--fx-surface-borderstrong, #CBD5E1)",
                }}
            >
                <Box
                    sx={{
                        width: 64,
                        height: 64,
                        mx: "auto",
                        mb: 2,
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        bgcolor: "var(--fx-colors-warning-50, #FFF7ED)",
                        color: colors.orange.base,
                    }}
                >
                    <FilterAltOffOutlined sx={{ fontSize: 30 }} />
                </Box>

                <Typography
                    sx={{
                        fontSize: 20,
                        fontWeight: 900,
                        color: "var(--fx-surface-text, #0F172A)",
                        mb: 1,
                    }}
                >
                    No timesheets match these filters
                </Typography>

                <Typography
                    sx={{
                        fontSize: 13,
                        color: "var(--fx-surface-textsecondary, #64748B)",
                        lineHeight: 1.6,
                        mb: onClearFilters ? 3 : 0,
                    }}
                >
                    Try changing the selected worker or date range to see more results.
                </Typography>

                {onClearFilters && (
                    <Button
                        variant="contained"
                        onClick={onClearFilters}
                        sx={{
                            bgcolor: colors.orange.base,
                            "&:hover": { bgcolor: colors.orange[600] },
                            textTransform: "none",
                            fontWeight: 900,
                            borderRadius: 2,
                            boxShadow: "none",
                            px: 2.5,
                        }}
                    >
                        Clear filters
                    </Button>
                )}
            </Box>
        </Box>
    );
}